import { motion } from "framer-motion";
import Navbar from "../../Navbar";
import Footer from "../../Footer";
import projects from "../../../data/projectData";

const ArrowIcon = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    viewBox="0 0 24 24"
    stroke="currentColor"
    fill="none"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M17 8l4 4m0 0l-4 4m4-4H3"
    />
  </svg>
);

const Project = () => {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <Navbar />

      <div className="flex-1 w-full max-w-6xl mx-auto pt-28 pb-16 px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => {
            const tags = project.tags.filter((t) => t);

            return (
              <motion.div
                key={index}
                className="bg-white rounded-2xl overflow-hidden flex flex-col shadow-[0_4px_24px_rgba(0,0,0,0.08),0_1px_4px_rgba(0,0,0,0.04)] hover:shadow-[0_20px_60px_rgba(0,0,0,0.15),0_4px_16px_rgba(0,0,0,0.08)] transition-shadow duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.4, delay: (index % 2) * 0.1 }}
              >
                <img
                  src={project.imageUrl}
                  alt={project.title}
                  className="w-full h-72 object-cover object-top"
                  draggable={false}
                />

                <div className="p-5 flex flex-col flex-1">
                  <h3 className="text-lg font-semibold text-gray-800">
                    {project.title}
                  </h3>
                  <p
                    className="mt-2 leading-relaxed text-sm text-gray-600 line-clamp-3"
                    dangerouslySetInnerHTML={{
                      __html: project.description,
                    }}
                  />
                  <ul className="flex flex-wrap mt-3 gap-1.5">
                    {tags.slice(0, 4).map((tag, i) => (
                      <li
                        key={i}
                        className="bg-gray-100 px-2 py-0.5 text-[0.7rem] text-gray-700 font-medium rounded-full"
                      >
                        {tag}
                      </li>
                    ))}
                    {tags.length > 4 && (
                      <li className="bg-gray-100 px-2 py-0.5 text-[0.7rem] text-gray-500 rounded-full">
                        +{tags.length - 4}
                      </li>
                    )}
                  </ul>

                  <div className="flex justify-start gap-2 pt-4 mt-auto">
                    {project.link && (
                      <a
                        className="flex items-center rounded-full text-xs bg-cyan-800 py-1.5 px-3 text-white hover:bg-sky-600 transition-colors"
                        href={project.link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {project.buttonType}
                        <ArrowIcon className="h-4 w-4 ml-1" />
                      </a>
                    )}
                    {project.route && (
                      <a
                        className="flex items-center border border-cyan-800 rounded-full text-xs py-1.5 px-3 text-cyan-900 hover:bg-sky-100 transition-colors"
                        href={project.route}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {project.buttonCta}
                        <ArrowIcon className="h-4 w-4 ml-1 text-cyan-800" />
                      </a>
                    )}
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>

      <div className="w-full">
        <Footer />
      </div>
    </div>
  );
};

export default Project;
